/* ********************************************************************************
   SigCapt.vue

   This is the main source file for running the sample and defining the HTML user interface

   Copyright (c) 2022 Wacom Co. Ltd.

***********************************************************************************/
<script>
/* eslint-disable */
import { ref, onMounted, computed } from '@vue/composition-api'
import { BButton } from 'bootstrap-vue';
import { WacomgssSignatureSDK } from "@/libs/wacom/wgssSigCaptX.js";
import store from '@/store';

export default {
  setup() {
    let imageBox;
    const callback = ref(null);
    const sigObj = ref(null);
    const sigCtl = ref(null);
    const dynCapt = ref(null);
    const hash = ref(null);
    const type = ref('');

    const signatureSrc = computed(() => store.getters['taxi/getTaxiSignatureData'].signatureSrc);
    const fname = computed(() => store.getters['taxi/taxi'].firstName);
    const lname = computed(() => store.getters['taxi/taxi'].lastName);
    const amount = computed(() => store.getters['taxiTransaction/payoutAmount']);

    const BITMAP_BACKGROUNDCOLOR = 0x00FFFFFF;
    const BITMAP_IMAGEFORMAT = "bmp";
    const BITMAP_INKCOLOR = 0x00000000;
    const BITMAP_INKWIDTH = 0.7;
    const BITMAP_PADDING_X = 4;
    const BITMAP_PADDING_Y = 4;
    const LICENCEKEY = "eyJhbGciOiJSUzUxMiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiI3YmM5Y2IxYWIxMGE0NmUxODI2N2E5MTJkYTA2ZTI3NiIsImV4cCI6MjE0NzQ4MzY0NywiaWF0IjoxNTYwOTUwMjcyLCJyaWdodHMiOlsiU0lHX1NES19DT1JFIiwiU0lHQ0FQVFhfQUNDRVNTIl0sImRldmljZXMiOlsiV0FDT01fQU5ZIl0sInR5cGUiOiJwcm9kIiwibGljX25hbWUiOiJTaWduYXR1cmUgU0RLIiwid2Fjb21faWQiOiI3YmM5Y2IxYWIxMGE0NmUxODI2N2E5MTJkYTA2ZTI3NiIsImxpY191aWQiOiJiODUyM2ViYi0xOGI3LTQ3OGEtYTlkZS04NDlmZTIyNmIwMDIiLCJhcHBzX3dpbmRvd3MiOltdLCJhcHBzX2lvcyI6W10sImFwcHNfYW5kcm9pZCI6W10sIm1hY2hpbmVfaWRzIjpbXX0.ONy3iYQ7lC6rQhou7rz4iJT_OJ20087gWz7GtCgYX3uNtKjmnEaNuP3QkjgxOK_vgOrTdwzD-nm-ysiTDs2GcPlOdUPErSp_bcX8kFBZVmGLyJtmeInAW6HuSp2-57ngoGFivTH_l1kkQ1KMvzDKHJbRglsPpd4nVHhx9WkvqczXyogldygvl0LRidyPOsS5H2GYmaPiyIp9In6meqeNQ1n9zkxSHo7B11mp_WXJXl0k1pek7py8XYCedCNW5qnLi4UCNlfTd6Mk9qz31arsiWsesPeR9PN121LBJtiPi023yQU8mgb9piw_a-ccciviJuNsEuRDN3sGnqONG3dMSA";
    const SERVICEPORT = 8000;
    const TIMEOUT = 150;

    const userMsg = (msg) => {
      console.log(msg)
    }

    const timedDetect = () => {
      if (window.wgssSignatureSDK.running) {
        start();
      }
      else {
        userMsg("Signature SDK Service not detected.");
      }
    }

    const onDetectRunning = () => {
      if (window.wgssSignatureSDK.running) {
        clearTimeout(window.timeout);
        start();
      }
      else {
        userMsg("Signature SDK Service not detected.");
      }
    }

    const start = () => {
      if (window.wgssSignatureSDK.running) {
        sigCtl.value = new window.wgssSignatureSDK.SigCtl(onSigCtlConstructor);
      }
    }

    const onSigCtlConstructor = (sigCtlV, status) => {
      if (callbackStatusOK("SigCtl constructor", status)) {
        sigCtl.value.PutLicence(LICENCEKEY, onSigCtlPutLicence);
      }
    }

    const onSigCtlPutLicence = (sigCtlV, status) => {
      if (callbackStatusOK("SigCtl PutLicence", status)) {
        dynCapt.value = new window.wgssSignatureSDK.DynamicCapture(onDynCaptConstructor);
      }
    }

    const onDynCaptConstructor = (dynCaptV, status) => {
      if (callbackStatusOK("DynCapt constructor", status)) {
        sigCtl.value.GetSignature(onGetSignature);
      }
    }

    const onGetSignature = (sigCtlV, sigObjV, status) => {
      if (callbackStatusOK("SigCapt GetSignature", status)) {
        sigObj.value = sigObjV;
        sigCtl.value.GetProperty("Component_FileVersion", onSigCtlGetFileVersion);
      }
    }

    const onSigCtlGetFileVersion = (sigCtlV, property, status) => {
      if (callbackStatusOK("SigCtl GetProperty", status)) {
        dynCapt.value.GetProperty("Component_FileVersion", onDynCaptGetFileVersion);
      }
    }

    const onDynCaptGetFileVersion = (dynCaptV, property, status) => {
      if (callbackStatusOK("DynCapt GetProperty", status)) {

        if (typeof (callback.value) === "function") {
          callback.value();
        }
      }
    }

    const actionWhenRestarted = (_callback) => {
      callback.value = _callback;
      sigObj.value = null;
      sigCtl.value = null;
      dynCapt.value = null;
      window.wgssSignatureSDK = null;

      window.timeout = setTimeout(timedDetect, TIMEOUT);

      // pass the starting service port  number as configured in the registry
      window.wgssSignatureSDK = new WacomgssSignatureSDK(onDetectRunning, SERVICEPORT);
    }

    const bodyonload = () => {
      imageBox = document.getElementById("imageBox");

      actionWhenRestarted();
    }

    // This function calculates a hash value using the first and last names on the HTML form
    const GetHash = (_hash, _type) => {
      hash.value = _hash;
      type.value = _type;
      hash.value.Clear(onClear);
    }

    const onClear = (hashV, status) => {
      if (callbackStatusOK("Hash Clear", status)) {
        hashV.PutType(window.wgssSignatureSDK.HashType.HashMD5, onPutType);
      }
    }

    const onPutType = (hashV, status) => {
      if (callbackStatusOK("Hash PutType", status)) {
        const vFname = new window.wgssSignatureSDK.Variant();
        vFname.Set(fname.value);
        hashV.Add(vFname, onAddFname);
      }
    }

    const onAddFname = (hashV, status) => {
      if (callbackStatusOK("Hash Add", status)) {
        const vLname = new window.wgssSignatureSDK.Variant();
        vLname.Set(lname.value);
        hashV.Add(vLname, onAddLname);
      }
    }

    const onAddLname = (hashV, status) => {
      if (callbackStatusOK("Hash Add", status)) {
        onGetInitialHash();
      }
    }

    // If the hash value has been calculated successfully next steps is to capture the signature
    const onGetInitialHash = () => {
      const fullName = fname.value + " " + lname.value;

      dynCapt.value.Capture(sigCtl.value, fullName, `Approve £${amount.value} transaction`, hash.value, null, onDynCaptCapture);
    }

    const onDynCaptCapture = (dynCaptV, SigObjV, status) => {
      let outputFlags = null;

      if (window.wgssSignatureSDK.ResponseStatus.INVALID_SESSION === status) {
        userMsg("Error: invalid session. Restarting the session.");
        actionWhenRestarted(window.Capture);
      }
      else {
        /* Check the status returned from the signature capture */
        switch (status) {
          case window.wgssSignatureSDK.DynamicCaptureResult.DynCaptOK:
            sigObj.value = SigObjV;
            userMsg("Signature captured successfully");

            outputFlags = window.wgssSignatureSDK.RBFlags.RenderOutputPicture | window.wgssSignatureSDK.RBFlags.RenderColor32BPP;

            sigObj.value.RenderBitmap(BITMAP_IMAGEFORMAT, imageBox.clientWidth, imageBox.clientHeight, BITMAP_INKWIDTH, BITMAP_INKCOLOR, BITMAP_BACKGROUNDCOLOR, outputFlags, BITMAP_PADDING_X, BITMAP_PADDING_Y, onRenderBitmap);
            break;

          case window.wgssSignatureSDK.DynamicCaptureResult.DynCaptCancel:
            userMsg("Signature capture cancelled");
            break;

          case window.wgssSignatureSDK.DynamicCaptureResult.DynCaptPadError:
            userMsg("No capture service available");
            break;

          case window.wgssSignatureSDK.DynamicCaptureResult.DynCaptError:
            userMsg("Tablet Error");
            break;

          case window.wgssSignatureSDK.DynamicCaptureResult.DynCaptNotLicensed:
            userMsg("No valid Signature Capture licence found");
            break;

          default:
            userMsg("Capture Error " + status);
            break;
        }
      }
    }

    const onRenderBitmap = (sigObjV, bmpObj, status) => {
      if (callbackStatusOK("Signature Render Bitmap", status)) {
        store.dispatch('taxi/modifySignatureData', { signatureSrc: bmpObj.image.src });
      }
    }

    /* This function simply checks the response status set by the previous callback routine and returns true or false.
    If an error status is found an error message is printed containing the name of the calling routine from
    the parameter and the status code */
    const callbackStatusOK = (methodName, status) => {
      if (window.wgssSignatureSDK.ResponseStatus.OK === status) {
        return true;
      }
      else {
        userMsg(methodName + " error: " + status);
        return false;
      }
    }

    const onInitialHashConstructor = (hashV, status) => {
      if (window.wgssSignatureSDK.ResponseStatus.OK === status) {
        GetHash(hashV, "INITIAL");
      }
      else {
        userMsg("Hash Constructor error: " + status);
        if (window.wgssSignatureSDK.ResponseStatus.INVALID_SESSION === status) {
          userMsg("Error: invalid session. Restarting the session.");
          actionWhenRestarted(window.Capture);
        }
      }
    }

    /*  This is the main function for capturing the signature from the pad */
    const capture = () => {

      userMsg("Starting capture");

      if (!window.wgssSignatureSDK.running || dynCapt.value === null) {
        userMsg("Session error. Restarting the session.");
        actionWhenRestarted(window.Capture);
        return;
      }

      // Construct a hash object to contain the hash
      const hash = new window.wgssSignatureSDK.Hash(onInitialHashConstructor);
    }

    onMounted(() => {
      bodyonload();
    })

    return {
      signatureSrc,
      capture,
    }
  },
  components: {
    BButton,
  }
};
</script>

<template>
  <div>
    <div
      id="imageBox"
      class="d-flex align-items-center justify-content-between w-100"
    >
      <img :src="signatureSrc">
    </div>

    <div class="d-flex align-items-center justify-content-end mb-3">
      <b-button
        @click="capture"
        class="mb-50"
        variant="outline-dark"
        pill
        size="sm"
      >
        Sign
      </b-button>
    </div>
  </div>
</template>

<style scoped>
#imageBox {
  height: 35mm;
  border: 1px solid #d3d3d3;
  margin-bottom: 10px;
}
</style>
